module.exports = __webpack_public_path__ + "static/media/plus-blue.feb25761.svg";